import { render, staticRenderFns } from "./MenuPrint.vue?vue&type=template&id=3aabc3ed&"
import script from "./MenuPrint.vue?vue&type=script&lang=js&"
export * from "./MenuPrint.vue?vue&type=script&lang=js&"
import style0 from "./MenuPrint.vue?vue&type=style&index=0&id=3aabc3ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports